module.exports = __webpack_public_path__ + "img/person.6b7c5eba.svg";